import { Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { RequestComponent } from './request/request.component';
import { RequestDetailComponent } from './request-detail/request-detail.component';
import {
    AUTH_ROUTES,
    canActivateAdmin,
    canActivateRequests,
    canActivateTasks,
    canActivateUser
} from '@shs-digi-care-monorepo/frontend-lib';
import { MenuComponent } from './menu/menu.component';
import { TasksComponent } from './requests/tasks.component';

export const APP_ROUTES: Routes = [
    {
        path: '',
        component: MenuComponent,
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'request',
        component: RequestComponent,
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'request/:id',
        component: RequestDetailComponent,
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'requests',
        component: TasksComponent,
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateRequests],
        data: { mode: 'requests' }
    },
    {
        path: 'tasks',
        component: TasksComponent,
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateTasks],
        data: { mode: 'tasks' }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateAdmin]
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'auth',
        children: AUTH_ROUTES
    },
    {
        path: '**',
        redirectTo: ''
    }
];
